// extracted by mini-css-extract-plugin
export default {"wrapper":"vy-z","response":"wy-z","error":"xy-z","disabled":"yy-z","buttons":"zy-z","feedbackQuestionSection":"Ay-z","yesNoWrapper":"By-z"};